import script from "./StockAlertContent.vue?vue&type=script&setup=true&lang=js"
export * from "./StockAlertContent.vue?vue&type=script&setup=true&lang=js"

import "./StockAlertContent.vue?vue&type=style&index=0&id=688ec5e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-688ec5e4"]])

export default __exports__